export default "__VITE_ASSET__3JH1HPGV__"